import React, { ReactNode } from 'react';

import {
  logCritical,
  logVerbose,
} from '@savgroup-front-common/configuration/appInsights/AppInsights';

import { buildPageTitle } from '../../helpers';

import ChunkLoadErrorBoundary from './ChunkLoadErrorBoundary';
import { isChunkLoadError } from './ErrorBoundary.helpers';
import ErrorBoundyTemplate from './ErrorBoundyTemplate';
import messages from './messages';

interface ComponentErrorBoundaryProps {
  home?: string;
  fallback?: ReactNode;
  children: ReactNode;
}

class ComponentErrorBoundary extends React.Component<
  ComponentErrorBoundaryProps,
  { hasError: boolean; hasChunkLoadError: boolean; errorMessage?: string }
> {
  constructor(props: ComponentErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, hasChunkLoadError: false };
  }

  componentDidCatch(error: any, errorInfo: any) {
    if (isChunkLoadError(error)) {
      this.setState({ hasChunkLoadError: true });

      logVerbose(error, { errorInfo });

      return;
    }

    const errorMessage = error?.message;

    this.setState({ hasError: true, errorMessage });

    logCritical(error, { errorInfo });

    if (!this.props.fallback) {
      document.title = buildPageTitle([messages.title]);
    }
  }

  render() {
    const { children, home, fallback } = this.props;
    const { hasError, hasChunkLoadError, errorMessage } = this.state;

    if ((hasError || hasChunkLoadError) && fallback) {
      return fallback;
    }

    if (hasChunkLoadError) {
      return <ChunkLoadErrorBoundary isFullScreen={false} />;
    }

    if (hasError) {
      return <ErrorBoundyTemplate home={home} errorMessage={errorMessage} />;
    }

    return children;
  }
}

export default ComponentErrorBoundary;
